import { render } from "./InputEmojiSelector.vue?vue&type=template&id=122ea3d9"
import script from "./InputEmojiSelector.vue?vue&type=script&lang=ts"
export * from "./InputEmojiSelector.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
